import { render, staticRenderFns } from "./IndicatorPenaltyEffectiveness.vue?vue&type=template&id=26afeec4&scoped=true"
import script from "./IndicatorPenaltyEffectiveness.vue?vue&type=script&lang=js"
export * from "./IndicatorPenaltyEffectiveness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afeec4",
  null
  
)

export default component.exports